import React, { useState } from "react";
import { Constant } from "../../../../helper/constant";
import { useNavigate } from "react-router-dom";

import "./inputDoctorAndPatient.css";

const InputDoctorAndPatient = ({
  doctorData,
  setDoctorData,
  patientData,
  setPatientData,
}) => {
  // =====================
  // Constant Definition
  // =====================

  const navigate = useNavigate();
  const [suggestionDoctor, setSuggestionDoctor] = useState([]);
  const [suggestionPatient, setSuggestionPatient] = useState([]);

  // =====================
  // Common Method
  // =====================

  const checkDoctorAutoComplete = (keyword) => {
    if (keyword.length > 1) {
      findDoctor(keyword);
    } else {
      setSuggestionDoctor([]);
    }
  };

  const checkPatientAutoComplete = (keyword) => {
    if (keyword.length > 1) {
      findPatient(keyword);
    } else {
      setSuggestionPatient([]);
    }
  };

  const selectDoctor = (doctor) => {
    setDoctorData({
      doctor_id: doctor.doctor_id,
      doctor_name: doctor.doctor_name,
    });
    setSuggestionDoctor([]);
  };

  const selectPatient = (patient) => {
    setPatientData({
      patient_id: patient.patient_id,
      patient_name: patient.patient_name,
    });
    setSuggestionPatient([]);
  };

  // =====================
  // Request Method
  // =====================

  const findDoctor = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/dokter/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setSuggestionDoctor(data.doctors);
    } catch (error) {
      setSuggestionDoctor([]);
    }
  };

  const findPatient = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/pasien/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setSuggestionPatient(data.patients);
    } catch (error) {
      setSuggestionPatient([]);
    }
  };

  return (
    <div className="input-transaksi-container">
      <div className="input-field-transaksi-nama-dokter-container">
        <p>Nama Dokter</p>
        <input
          className="input-field-transaksi-nama-dokter"
          type="text"
          value={doctorData.doctor_name ? doctorData.doctor_name : ""}
          onChange={(e) => {
            setDoctorData({
              doctor_id: "",
              doctor_name: e.target.value,
            });
            checkDoctorAutoComplete(e.target.value);
          }}
          placeholder="Masukkan nama dokter"
        />
        {suggestionDoctor.length > 0 && (
          <ul className="dropdown-list">
            {suggestionDoctor.map((doctor) => (
              <li key={doctor.doctor_id}>
                <button
                  className="dropdown-button"
                  onClick={() => {
                    selectDoctor(doctor);
                  }}
                >
                  {doctor.doctor_name}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="input-field-transaksi-nama-pasien-container">
        <p>Nama Pasien</p>
        <input
          className="input-field-transaksi-nama-pasien"
          type="text"
          value={patientData.patient_name ? patientData.patient_name : ""}
          onChange={(e) => {
            setPatientData({
              patient_id: "",
              patient_name: e.target.value,
            });
            checkPatientAutoComplete(e.target.value);
          }}
          placeholder="Masukkan nama pasien"
        />
        {suggestionPatient.length > 0 && (
          <ul className="dropdown-list">
            {suggestionPatient.map((patient) => (
              <li key={patient.patient_id}>
                <button
                  className="dropdown-button"
                  onClick={() => {
                    selectPatient(patient);
                  }}
                >
                  {patient.patient_name} | No Pasien:{" "}
                  <b>{patient.patient_number}</b>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default InputDoctorAndPatient;
